module.exports = __webpack_public_path__ + "static/media/googlePlay.866b363a.svg";